// extracted by mini-css-extract-plugin
module.exports = {"manage-skill-tags":"g3rSv","manage-skill-tags_one-line-text":"_3KRGw","manage-skill-tags_panel-wrapper":"_3FVRJ","status-icon":"_1rZQl"};